import StudentsProgressBar from "./students-progressbar";
import DefaultProgress from "./default-progress";

export default { StudentsProgressBar, DefaultProgress };
